import React from 'react';

import DefecationButton from './DefecationButton';
import MealButton from './MealButton';
import MedicationButton from './MedicationButton';
import MilkButton from './MilkButton';
import SleepButton from './SleepButton';
import TemperatureButton from './TemperatureButton';
import WakeupButton from './WakeupButton';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { HealthRecordTypeType } from '@/types/domain/class/valueObjects/healthRecordType';
import type { UserType } from '@/types/domain/user/redux';

/** 入力 */
export type LineButtonsInput = {
  /** 日付 */
  date: string,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
  /** 表示対象 */
  healthRecordTypes: HealthRecordTypeType[],
  /** 睡眠を昨日で登録 */
  isYesterdaySleep: boolean,
};

const LineButtons: React.FC<LineButtonsInput> = ({
  date,
  user,
  child,
  facilityList,
  healthRecordTypes,
  isYesterdaySleep,
}) => {
  const dateTime = new Date(date);
  return (
    <div style={{
      alignItems: 'center',
      flexWrap: 'wrap',
      width: '100%',
    }}
    >
      {healthRecordTypes.includes('体温') && (
        <TemperatureButton
          date={dateTime}
          user={user}
          child={child}
          facilityList={facilityList}
        />
      )}
      {healthRecordTypes.includes('睡眠') && (
        <>
          <SleepButton
            date={dateTime}
            user={user}
            child={child}
            facilityList={facilityList}
            isYesterday={isYesterdaySleep}
          />
          <WakeupButton
            date={dateTime}
            user={user}
            child={child}
            facilityList={facilityList}
          />
        </>
      )}
      {healthRecordTypes.includes('排泄') && (
        <DefecationButton
          date={dateTime}
          user={user}
          child={child}
          facilityList={facilityList}
        />
      )}
      {healthRecordTypes.includes('ミルク') && (
        <MilkButton
          date={dateTime}
          user={user}
          child={child}
          facilityList={facilityList}
        />
      )}
      {healthRecordTypes.includes('食事') && (
        <MealButton
          date={dateTime}
          user={user}
          child={child}
          facilityList={facilityList}
        />
      )}
      {healthRecordTypes.includes('薬') && (
        <MedicationButton
          date={dateTime}
          user={user}
          child={child}
          facilityList={facilityList}
        />
      )}
    </div>
  );
};

export default LineButtons;
